import { Wrench } from 'lucide-react';

interface SMPMaintenanceBannerProps {
  'data-testid'?: string;
}

export const SMPMaintenanceBanner = ({
  'data-testid': testId = 'smp-maintenance-banner',
}: SMPMaintenanceBannerProps) => (
  <div
    className="w-full rounded-lg bg-background-maintenance px-6 py-5"
    data-testid={testId}
  >
    <div className="flex items-start gap-4">
      <Wrench
        className="mt-0.5 size-6 shrink-0 text-white"
        aria-hidden="true"
      />
      <div className="flex flex-col gap-2">
        <h3 className="typography-title text-white">Scheduled Maintenance</h3>
        <p className="typography-body text-white/90">
          We&apos;re performing system maintenance to improve your experience.
          Some features will be temporarily unavailable.
        </p>
        <p className="typography-body text-white/90">
          We apologize for any inconvenience.
        </p>
      </div>
    </div>
  </div>
);
